import { STableActions } from 'shj-components'
import styles from './index.module.less'
import { forwardRef, useImperativeHandle, useState } from 'react'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { Tooltip } from 'antd'
import SubMaterialModal from '@/components/SubMaterialModal'

export default forwardRef(function ProductCard(props: any, ref) {
  const { item, btnClick } = props
  const [openSubModal, setOpenSubModal] = useState(false)
  const [subMaterialInfo, setSubMaterialInfo] = useState({})
  const [subNumber, setSubNumber] = useState(0)

  const typeMap = {
    增项: {
      text: '增项',
      className: 'ADD-Status',
    },
    升降级: {
      text: '升降级',
      className: 'UP_DOWN-Status',
    },
    活动: {
      text: '优惠',
      className: 'ACTIVITY-Status',
    },
    标配: {
      text: '标配',
      className: 'STANDARD-Status',
    },
    减项: {
      text: '减项',
      className: 'SUB-Status',
    },
  }

  const clickToHandle = (type: string) => {
    btnClick(type)
  }

  const handleOpenSubModal = (item: any) => {
    setSubMaterialInfo(item)
    setSubNumber(item.replaceFlag ? item.replaceNum || 0 : item.displayQtyValue || 0)
    setOpenSubModal(true)
  }

  const renderBtnGroup = (item: any) => {
    const canEdit = !item.replaceFlag && !item.errMessage
    return (
      <STableActions>
        {canEdit && (
          <STableActions.SActionBtn
            disabled={item.limitUpdate}
            onClick={() => clickToHandle('BudgetQty')}
          >
            预算量
          </STableActions.SActionBtn>
        )}

        {item.refTypeName === '标配' &&
          canEdit &&
          item.refTypeName !== '减项' &&
          !item.refDeductId  && (
            <STableActions.SActionBtn
              disabled={item.limitUpdate}
              onClick={() => clickToHandle('replace')}
            >
              替换量
            </STableActions.SActionBtn>
          )}
        {canEdit && (
          <STableActions.SActionBtn
            disabled={item.limitUpdate}
            onClick={() => clickToHandle('remark')}
          >
            备注
          </STableActions.SActionBtn>
        )}
        {!item.templateFlag &&
          item.chooseFormatFlag &&
          canEdit &&
          item.refTypeName !== '减项' &&
          !item.refDeductId  && (
            <STableActions.SActionBtn
              disabled={item.limitUpdate}
              onClick={() => clickToHandle('modifyDynamic')}
            >
              修改规格
            </STableActions.SActionBtn>
          )}
        {item.packDtlList &&
          !!item.packDtlList.length &&
          canEdit &&
          item.refTypeName !== '减项' &&
          !item.refDeductId  && (
            <STableActions.SActionBtn
              disabled={item.limitUpdate}
              onClick={() => clickToHandle('productDetail')}
            >
              产品明细
            </STableActions.SActionBtn>
          )}

        {item.skuDynamicVoList &&
          !!item.skuDynamicVoList.length &&
          canEdit &&
          item.refTypeName !== '减项' &&
          !item.refDeductId  &&(
            <STableActions.SActionBtn
              disabled={item.limitUpdate}
              onClick={() => clickToHandle('SkuDynamic')}
            >
              报价属性
            </STableActions.SActionBtn>
          )}
        {(!item.presetFlag || (item.presetFlag && item.replaceFlag)) && (
          <STableActions.SActionBtn
            disabled={(!item.deletedFlag && !item.errMessage) || item.limitUpdate}
            onClick={() => clickToHandle('delete')}
          >
            删除
          </STableActions.SActionBtn>
        )}
      </STableActions>
    )
  }
  const timeTransform = (time: string) => {
    return new Date(time).toLocaleDateString()
  }
  return (
    <div className={`${styles.productCardBox}  ${item.replaceFlag ? 'replaceStyle' : ''} `}>
      {/* 产品类型 */}
      <div className={`${styles.typeBox} ${typeMap[item.refTypeName]?.className}`}>
        {typeMap[item.refTypeName]?.text}
      </div>
      {/* 状态 */}
      {item.replaceFlag && <div className={styles.replaceBox}>替换</div>}

      <div className={styles.imageBox} onClick={() => clickToHandle('preview')}>
        {item.errMessage && <div className={`${styles.errorBox}`}>已失效</div>}
        {item.replaceFlag && <div className={`${styles.errorBox}`}></div>}
        <img src={item.mainPic} alt="" />
      </div>
      <Tooltip title={item.name}>
        <p
          className={`${styles.productNameBox} ${item.replaceFlag ? 'replaceStyleLine' : ''}  ${
            item.errMessage ? styles.errorColor : ''
          }`}
        >
          {item.name}
        </p>
      </Tooltip>
      <Tooltip title={item.remark}>
        <p className={styles.remarkBox}>
          {!item.errMessage && !item.replaceFlag ? `备注:${item.remark || ''}` : ''}
        </p>
      </Tooltip>
      <p className={styles.priceBox}>
        <p>单价: ￥{item.saleCustPrice || 0}</p>
        <p>数量: {item.replaceFlag ? item.replaceNum || 0 : item.displayQtyValue || 0}</p>
        {!item.replaceFlag && item.replaceNum > 0 && <p>替换: {item.replaceNum || 0}</p>}
      </p>
      <p className={styles.totalPriceBox}>
        <p className={`${item.errMessage ? styles.errorColor : ''}`}>
          合计
          <span className={`${item.replaceFlag ? styles.errMoneyNumber : styles.moneyNumber}`}>
            {' '}
            ￥{item.budgetAmount || 0}
            {typeMap[item.refTypeName]?.text === '减项' ? (
              <span
                style={{
                  height: '18px',
                  width: '18px',
                  color: '#000',
                  marginLeft: '5px',
                  cursor: 'pointer',
                }}
                onClick={() => handleOpenSubModal(item)}
              >
                <QuestionCircleOutlined style={{ height: '18px', width: '18px', color: '#000' }} />
              </span>
            ) : null}
          </span>
        </p>
      </p>
      <p className={styles.deadLineBox}>
        {item.outOfStockTime && !item.replaceFlag
          ? '预计' + timeTransform(item.outOfStockTime) + '下架'
          : ''}
      </p>
      <div className={styles.buttonBox}>{renderBtnGroup(item)}</div>
      {openSubModal && (
        <SubMaterialModal
          subNumber={subNumber}
          subMaterialInfo={subMaterialInfo}
          open={openSubModal}
          onClose={() => setOpenSubModal(false)}
        />
      )}
    </div>
  )
})
